var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-card-text", { staticClass: "black--text" }, [
    _c("h1", { staticClass: "mb-3" }, [
      _vm._v("Weitere Informationen zu Cookies")
    ]),
    _c("h3", [_vm._v("Was ist ein Cookie?")]),
    _c("p", [
      _vm._v(
        "Als Cookies bzw. Cookie wird in HTTP als Textdatei bezeichnet - eine kleine Datenmenge, die Server an den Browser senden. Er speichert sie auf dem Computer des Benutzers. Bei jedem Besuch der Seite sendet der Browser diese Daten an den Server zurück."
      )
    ]),
    _c("p", [
      _vm._v(
        'Cookies werden in der Regel verwendet, um einzelne Benutzer zu unterscheiden, sie speichern typischerweise den Inhalt des "Warenkorbs" im E-Shop, Benutzereinstellungen und mehr. Technisch gesehen handelt es sich um eine Reihe von Codes, die der Browser sammelt und dann Informationen über Ihr Verhalten an den entsprechenden Server zurücksendet. Cookies enthalten Informationen darüber, wie lange der Browser sie speichern soll (von einmalig bis zu mehreren Jahren).'
      )
    ]),
    _c("p", [
      _vm._v(
        "Cookies sind nicht direkt mit Ihrem Namen oder Ihrer E-Mail-Adresse verknüpft, enthalten jedoch häufig Ihre Zugangsdaten zum System. Sie sind für eine Browserinstallation üblich. Cookies werden in keiner Weise gesichert, einschließlich der gesammelten Daten."
      )
    ]),
    _c("h3", [_vm._v("Welche Cookies verwenden wir?")]),
    _c("p", [
      _vm._v(
        "Wir verwenden Cookies von Drittanbietern, insbesondere Google Analytics zur Verkehrsanalyse. Diese Cookies werden von Dritten kontrolliert und wir haben keinen Zugriff, um diese Daten zu lesen oder zu schreiben. Sie können hier über die Bedingungen für die Verwendung von Google Analytics lesen "
      ),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage"
          }
        },
        [_vm._v("hier")]
      ),
      _vm._v(".")
    ]),
    _c("h3", [_vm._v("Was kannst du tun?")]),
    _c("p", [
      _vm._v(
        'Sie können Cookies ablehnen oder bei Bedarf löschen. Anweisungen dazu finden Sie im Abschnitt "Hilfe" Ihres Webbrowsers.'
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }